<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page erp-area-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="24">
              <a-form-item label="区域名称">
                <a-input v-model="query.areaName" allow-clear placeholder="请输入" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions">
              <a-button type="primary" icon="search" @click="search">搜索</a-button>
              <a-button icon="redo" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div>
            <h3>区域</h3>
            <p>区域数据来自华住开放接口。华住有哪些区域，业务侧才能选择哪些区域。</p>
          </div>
          <div class="erp-toolbar-actions">
            <a-button icon="plus-square" title="展开到市级（区县请按行展开，避免一次渲染卡顿）" :disabled="!rows.length" @click="expandAll">全部展开</a-button>
            <a-button icon="minus-square" :disabled="!rows.length" @click="collapseAll">全部折叠</a-button>
            <a-button type="primary" icon="cloud-download" :loading="syncing" @click="syncRegions">获取区域</a-button>
          </div>
        </div>
        <a-table
          row-key="areaId"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="false"
          :expanded-row-keys="expandedKeys"
          bordered
          size="middle"
          :scroll="{ x: 960 }"
          @expandedRowsChange="onExpandedRowsChange">
          <template slot="validFlag" slot-scope="value">
            <a-tag :color="Number(value) === 1 ? 'green' : 'default'">{{ Number(value) === 1 ? '有效' : '无效' }}</a-tag>
          </template>
          <template slot="source" slot-scope="value">
            {{ value === 'huazhu' ? '华住同步' : (value || '—') }}
          </template>
          <template slot="level" slot-scope="value">
            {{ levelText(value) }}
          </template>
        </a-table>
      </div>
    </div>
  </page-header-wrapper>
</template>

<script>
import { getAreaTree, listArea, syncAreaFromHuazhu } from '@/api/system/area'

export default {
  name: 'ErpArea',
  data () {
    return {
      loading: false,
      syncing: false,
      query: { areaName: '' },
      allRows: [],
      rows: [],
      expandedKeys: [],
      columns: [
        { title: '区域名称', dataIndex: 'areaName', width: 220 },
        { title: '区域编码', dataIndex: 'areaCode', width: 140 },
        { title: '全称', dataIndex: 'fullName', width: 260 },
        { title: '层级', dataIndex: 'level', width: 100, scopedSlots: { customRender: 'level' } },
        { title: '状态', dataIndex: 'validFlag', width: 100, scopedSlots: { customRender: 'validFlag' } },
        { title: '来源', dataIndex: 'source', width: 120, scopedSlots: { customRender: 'source' } }
      ]
    }
  },
  created () {
    this.load()
  },
  methods: {
    levelText (value) {
      const map = { 1: '省/直辖市', 2: '市', 3: '区县' }
      return map[Number(value)] || (value == null ? '—' : String(value))
    },
    normalizeTree (nodes) {
      return (nodes || []).map(node => {
        const children = this.normalizeTree(node.children || [])
        const areaId = node.areaId != null ? node.areaId : node.id
        const item = {
          areaId,
          areaCode: node.areaCode || '',
          areaName: node.areaName || node.name || '',
          fullName: node.fullName || node.areaName || node.name || '',
          level: node.level,
          validFlag: node.validFlag,
          source: node.source,
          children: children.length ? children : undefined
        }
        return item
      }).filter(item => item.areaId != null || item.areaName)
    },
    normalizeFlat (rows) {
      return (rows || []).map(row => ({
        areaId: row.areaId,
        areaCode: row.areaCode || '',
        areaName: row.areaName || '',
        fullName: row.fullName || row.areaName || '',
        level: row.level,
        validFlag: row.validFlag,
        source: row.source
      })).filter(row => row.areaId != null)
    },
    filterTree (nodes, keyword) {
      if (!keyword) return nodes
      const kw = keyword.toLowerCase()
      const walk = list => {
        const out = []
        ;(list || []).forEach(node => {
          const children = walk(node.children || [])
          const hit = String(node.areaName || '').toLowerCase().includes(kw)
            || String(node.fullName || '').toLowerCase().includes(kw)
            || String(node.areaCode || '').toLowerCase().includes(kw)
          if (hit || children.length) {
            out.push({ ...node, children: children.length ? children : undefined })
          }
        })
        return out
      }
      return walk(nodes)
    },
    /**
     * 收集可展开节点。
     * maxDepth：展开层数，1=仅省级（露出市），2=省+市（露出全部区县，约三千行会卡）。
     */
    collectExpandableKeys (nodes, maxDepth) {
      const depthLimit = maxDepth == null ? 99 : maxDepth
      const keys = []
      const walk = (list, depth) => {
        ;(list || []).forEach(node => {
          if (node.children && node.children.length && depth < depthLimit) {
            keys.push(node.areaId)
            walk(node.children, depth + 1)
          }
        })
      }
      walk(nodes, 0)
      return keys
    },
    countNodes (nodes) {
      let total = 0
      const walk = list => {
        ;(list || []).forEach(node => {
          total += 1
          walk(node.children)
        })
      }
      walk(nodes)
      return total
    },
    onExpandedRowsChange (keys) {
      this.expandedKeys = keys || []
    },
    expandAll () {
      // 只展开到市级，避免一次挂载全部区县导致页面卡死
      this.expandedKeys = this.collectExpandableKeys(this.rows, 1)
    },
    collapseAll () {
      this.expandedKeys = []
    },
    load () {
      this.loading = true
      // 优先树；树异常时回退扁平列表，避免「获取区域」后空白
      return getAreaTree().then(res => {
        const tree = this.normalizeTree(res.data || [])
        if (tree.length) {
          this.allRows = tree
          this.applyFilter(false)
          return
        }
        return listArea({}).then(listRes => {
          this.allRows = this.normalizeFlat(listRes.data || [])
          this.applyFilter(false)
        })
      }).catch(() => listArea({}).then(listRes => {
        this.allRows = this.normalizeFlat(listRes.data || [])
        this.applyFilter(false)
      })).finally(() => { this.loading = false })
    },
    applyFilter (keepExpand) {
      this.rows = this.filterTree(this.allRows, (this.query.areaName || '').trim())
      if (!keepExpand) {
        // 默认折叠；搜索结果较小时可多展一层，否则只展到市
        if ((this.query.areaName || '').trim()) {
          const depth = this.countNodes(this.rows) <= 300 ? 2 : 1
          this.expandedKeys = this.collectExpandableKeys(this.rows, depth)
        } else {
          this.expandedKeys = []
        }
      }
    },
    search () {
      this.applyFilter(false)
    },
    reset () {
      this.query.areaName = ''
      this.applyFilter(false)
    },
    syncRegions () {
      this.syncing = true
      syncAreaFromHuazhu().then(res => {
        const count = res && res.data != null ? res.data : ''
        this.$message.success(count !== '' ? `获取区域成功，共同步 ${count} 条` : '获取区域成功')
        return this.load()
      }).catch(err => {
        this.$message.error((err && (err.msg || err.message)) || '获取区域失败')
      }).finally(() => { this.syncing = false })
    }
  }
}
</script>
